import type { ApiClient } from '../client'
import type {
  CandidateScoringReport,
  DuebackPerformanceReport,
  MessagingPerformanceReport,
  RecoveryPerformanceReport,
  ReportRangeQuery,
  RevenueAttributionReport,
} from '../types'

/**
 * src/modules/reports/controllers/reports.controller.ts
 *
 * Only `revenue-attribution` (and the export) honour `location_id`; the analytics ignore it
 * (BE-21), so the client never sends it to them.
 */
export function reportsEndpoints(api: ApiClient) {
  const range = (q: ReportRangeQuery) => ({ from: q.from, to: q.to })
  return {
    revenueAttribution: (q: ReportRangeQuery) =>
      api.get<RevenueAttributionReport>('reports/revenue-attribution', { query: { ...q } }),
    recoveryPerformance: (q: ReportRangeQuery) =>
      api.get<RecoveryPerformanceReport>('reports/recovery-performance', { query: range(q) }),
    duebackPerformance: (q: ReportRangeQuery) =>
      api.get<DuebackPerformanceReport>('reports/dueback-performance', { query: range(q) }),
    messagingPerformance: (q: ReportRangeQuery) =>
      api.get<MessagingPerformanceReport>('reports/messaging-performance', { query: range(q) }),
    candidateScoring: (q: ReportRangeQuery) =>
      api.get<CandidateScoringReport>('reports/candidate-scoring-analysis', { query: range(q) }),
    /** `text/csv` with the server's filename; ≤ 92 days and ≤ 10 000 rows (`EXPORT_TOO_LARGE`). */
    exportCsv: (q: ReportRangeQuery) =>
      api.requestDownload('reports/export.csv', { query: { ...q } }),
  }
}
